"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        fontSize: 14,
        lineHeight: `21px`,
        fontWeight: 400,
        color: theme.grey1
    }
});
//# sourceMappingURL=collection.description.style.js.map